import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import Calendar from '../../ui/Calendar'

@inject("store")
@observer
export default class TimeChooser extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    onChange: PropTypes.func
  }

  handleClick = (e, slot) => {
    const { store } = this.props
    e.preventDefault()
    store.progress({ slot })
  }

  render() {
    const { store } = this.props

    return (
      <div>
        { store.sortedSlots.map(slot =>
          <div key={slot.id}>
            <a
              href="#chooseSlot" 
              onClick={e => this.handleClick(e, slot)}
            >
              { slot.attributes.startsAt }
            </a>
          </div>
        )}
      </div>
    )
  }
}

const styles = {
  wrapper: {
    display: "inline-block"
  }
}
